module.exports = __webpack_public_path__ + "img/untitled.437.2f79e103.png";